import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["target", "template", "referenceTemplate"]

  add(e) {
    e.preventDefault()
    
    const type = e.params.type
    let content = ""

    if (type === "reference" && this.hasReferenceTemplateTarget) {
      content = this.referenceTemplateTarget.innerHTML
    } else {
      content = this.templateTarget.innerHTML
    }

    content = content.replace(/NEW_RECORD/g, new Date().getTime())
    this.targetTarget.insertAdjacentHTML('beforeend', content)
  }

  remove(e) {
    e.preventDefault()
    
    const wrapper = e.target.closest(".nested-fields")
    if (wrapper) {
      wrapper.remove()
    }
  }
}
